import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { navigationKeys } from "./navigationSource";

export function useNavigationText() {
  const { t } = useTranslation("navigation");
  return useCallback((source: string): string => {
    if (!Object.prototype.hasOwnProperty.call(navigationKeys, source)) return source;
    const key = navigationKeys[source as keyof typeof navigationKeys];
    return t($ => $[key]);
  }, [t]);
}

type NavigationNode = { id?: string; label: string; shortLabel?: string; items?: NavigationNode[]; groups?: NavigationNode[] };
export function localizeNavigation<T extends NavigationNode>(node: T, translate: (text: string) => string, preserveLabels?: ReadonlySet<string>): T {
  const preserve = node.id !== undefined && preserveLabels?.has(node.id);
  return {
    ...node, label: preserve ? node.label : translate(node.label), shortLabel: node.shortLabel ? preserve ? node.shortLabel : translate(node.shortLabel) : undefined,
    ...(node.items ? { items: node.items.map(child => localizeNavigation(child, translate, preserveLabels)) } : {}),
    ...(node.groups ? { groups: node.groups.map(child => localizeNavigation(child, translate, preserveLabels)) } : {}),
  };
}
